/**
 * @sw-package b2b
 */

import Plugin from 'src/plugin-system/plugin.class';
import DomAccess from 'src/helper/dom-access.helper';

type Options = {
    messageInputSelector?: string,
    messageTextareaSelector?: string,
    collapseElementSelector?: string,
};

export default class B2bQuoteMessage extends Plugin {
    static options: Options = {
        messageTextareaSelector: '.quote-detail-comment__textarea',
        messageInputSelector: '.quote-detail-comment__input',
        collapseElementSelector: '#sendComment',
    };

    private el: HTMLElement;

    public init(): void {
        const collapseElement = DomAccess.querySelector(document, this.options.collapseElementSelector, false) as HTMLElement;
        const messageInput = DomAccess.querySelector(this.el, this.options.messageInputSelector) as HTMLTextAreaElement;
        const messageTextarea = DomAccess.querySelector(this.el, this.options.messageTextareaSelector) as HTMLTextAreaElement;

        messageInput.addEventListener('focus', () => {
            const bsCollapse = new bootstrap.Collapse(this.options.collapseElementSelector);
            bsCollapse.show();
        });

        if (collapseElement) {
            collapseElement.addEventListener('hidden.bs.collapse', () => {
                messageTextarea.value = '';
            });

            collapseElement.addEventListener('shown.bs.collapse', () => {
                messageTextarea.focus();
            })
        }
    }
}
